export const GET_BRANCH = "GET_BRANCH";
export const ADD_BRANCH = "ADD_BRANCH";
export const GET_LICENSE = "GET_LICENSE";
export const ADD_LICENSE = "ADD_LICENSE";
export const UPDATE_BRANCH = "UPDATE_BRANCH";
export const DELETE_BRANCH = "DELETE_BRANCH";
export const GET_BRANCH_DETAILS = "GET_BRANCH_DETAILS";